import Vue from 'vue';
import { 
Validator, install as VeeValidate 
} from 'vee-validate/dist/vee-validate.minimal.esm.js';
import { 
required, date_format, email, numeric
} from 'vee-validate/dist/rules.esm.js';
import store from '@/store';
const { $gettext } = Vue.prototype;
Validator.localize('en', {
  attributes: {
    customer: $gettext('Customer name'),
    table: $gettext('Table'),
    room: $gettext('Room'),
    cover: $gettext('Covers'),
    staff: $gettext('Staff'),
    subRoles: $gettext('Permission'),
    firstName: $gettext('First name'),
    lastName: $gettext('Last name'),
    username: $gettext('Username'),
    ref: $gettext('Id'),
    name: $gettext('Name'),
    userGroup: $gettext('Staff group'),
    customerType: $gettext('Customer Type'),
    phone: $gettext('Phone'),
  },
  messages: {
    canPostBill: $gettext('Invalid staff ID'),
    numeric: field => field + ' ' + $gettext('is invalid'),
    required: field => field + ' ' + $gettext('can not empty'),
    required_if: $gettext('Please, enter table or room number!'),
    date_format: $gettext('Wrong date format'),
  },
});

const canPostBill = staffRef => {
  return store.getters.checkStaff(staffRef, 'ref');
};

Validator.extend('canPostBill', {
  validate: canPostBill,
  getMessage: (field, params, { message }) => message,
});

const uniqueRef = (staffRef, checkingStaff) => {
  const subLocations = checkingStaff.subLocations;
  const staffs = store.getters.getArray('staffs');
  const refs = {};
  staffs.forEach(staff => {
    if(!staff.subLocations 
        || staff.subLocations.length == 0
        || (checkingStaff.id && staff.id == checkingStaff.id)
      ) return;
    const intersection =  staff.subLocations
                            .filter(location => subLocations.includes(location));
    if(intersection.length > 0) {
      refs[staff.ref] = true;
    }
  });
  if(!Object.keys(refs).includes(staffRef)) return {valid: true};
  return {
    valid: false,
    data: {
      message: $gettext('Staff Id used in location')
    }
  };
};

Validator.extend('uniqueRef', {
  validate: uniqueRef,
  getMessage: (field, params, { message }) => message,
});

Validator.extend('required', required);
Validator.extend('date_format', date_format);
Validator.extend('numeric', numeric);
Validator.extend('email', email);

Vue.use(VeeValidate);

export default VeeValidate;
